import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { _ProductLot } from "../../../../../../../core/services/dataBean/EntityCatalogVdos";
import { Singleton } from "../../../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../../theme/Component/ModalConfirm";
import { YearSelector } from "../../../../../../../core/shared/inputs/YearSelector";
import { SelectProductEditor } from "../../../../../../Factoty&Production/ManufacturingStandars/Components/SelectProductEditor";
import { InputDate } from "../../../../../../theme/Input/InputDate";





export const ProductLotCatalogByProduct = () => {

    const lot = useDataBean(_ProductLot);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: '', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [year, setYear] = useState<number>(null)
    const [product, seProduct] = useState<number>(null)



    useEffect(() => {
        getLista()

    }, [product])


    const getLista = () => {

        lot.instance.getProductLotCatalogByProduct(year, product).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }

            }
        )

    }



    const create = () => {
        lot.setBean({
            Year: year,
            IDProduct: product
        });

        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        //console.log(Project.bean);
        lot.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }





    const head = [
        { title: 'ID', property: 'IDLot', visible: true },
        { title: 'Número de Lote', property: 'LotNumber', visible: true },
        { title: 'Fecha Empaque', property: 'ProductionDate', visible: true },
        { title: 'Fecha Vencimiento', property: 'DueDate', visible: true },
        { title: 'Número de Cajas', property: 'BoxNumber', visible: true },
        { title: 'Items por Caja', property: 'ItemsPerBox', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const deleteItem = () => {
        lot.deleteItemVoid(lot.bean.IDLot).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }

    return (
        <BasicPage titulo="Lotes de Producción / Producto">
            <div className="row">
                <div className="col-md-6">

                    <YearSelector value={year} onChange={(e) => { setYear(e) }} />
                </div>
                <div className="col-md-6">
                    <SelectProductEditor label="Producto" value={product} onChange={(e) => { seProduct(e.IDProduct) }} />
                </div>

                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={lot.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <label>Número de Lote</label>
                                    <input name="LotNumber" className="form-control" value={lot.bean.LotNumber} onChange={lot.handleChange} />
                                </div>
                                <div className="col-md-6">
                                    <label>Fecha Empaque</label>
                                    <InputDate name="desde" label="Hasta" value={lot.bean.ProductionDate} setDate={(e: any) => { lot.setBean({ ...lot.bean, "ProductionDate": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <label>Fecha Vencimiento</label>
                                    <InputDate name="desde" label="Hasta" value={lot.bean.DueDate} setDate={(e: any) => { lot.setBean({ ...lot.bean, "DueDate": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <label>Número de Cajas</label>
                                    <input name="BoxNumber" className="form-control" value={lot.bean.BoxNumber} onChange={lot.handleChange} />
                                </div>
                                <div className="col-md-6">
                                    <label>Items por Caja</label>
                                    <input name="ItemsPerBox" className="form-control" value={lot.bean.ItemsPerBox} onChange={lot.handleChange} />
                                </div>
                                <div className="col-md-12">
                                    <label>Descripción</label>
                                    <textarea name="Description" className="form-control" value={lot.bean.Description} onChange={lot.handleChange} />
                                </div>
                            </div>

                        </>
                    </Modal>


                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}